package one.healthium.base.utils

import androidx.compose.ui.geometry.Size
import one.primehealth.app.TargetPlatform
import one.primehealth.app.targetPlatform

enum class DeviceClass {
    Default,
    Plus,
    Mid,
    Low,
    i13Pro,
    i14Pro,
    Promax;

    companion object {
        fun from(size: Size): DeviceClass {
            if (targetPlatform() == TargetPlatform.Android) {
                return Default
            }

            val height = size.height.toInt()
            return when {
                height < 666 -> Low
                height in 666..735 -> Mid
                height in 736..812 -> Plus
                height in 843..850 -> i13Pro
                height in 851..894 -> i14Pro
                height in 895..1024 -> i14Pro
                else -> Default
            }
        }
    }
}